import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {NotificationModel} from '../../models/notification.model';
import {NotificationsState, NotificationsStore} from './notifications.store';

@Injectable({ providedIn: 'root' })
export class NotificationsQuery extends QueryEntity<NotificationsState, NotificationModel> {
  notifications$ = this.selectAll();
  planningSelectedDate$ = this.select((state: NotificationsState) => state.planningSelectedDate);
  loading$ = this.selectLoading();

  constructor(protected store: NotificationsStore) {
    super(store);
  }

}
